export const darkTheme = {
  bg: "#050505",
  bgLight: "#121212",
  primary: "#3b82f6",
  text_primary: "#f8fafc",
  text_secondary: "#94a3b8",
  card: "#0f172a",
  card_light: "#1e293b",
  button: "#3b82f6",
  white: "#FFFFFF",
  black: "#000000",
  glass: "rgba(255, 255, 255, 0.03)",
  border: "rgba(255, 255, 255, 0.12)",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#f0f0f0",
  primary: "#be1adb",
  text_primary: "#111111",
  text_secondary: "#48494a",
  card: "#FFFFFF",
  button: "#5c5b5b",
};
